import type {
  GlobalSearchArticle,
  GlobalSearchConfig,
} from "@appcaire/shared/seo";

export const SITE_ORIGIN = "https://hemtjanstistockholm.se";
export const STOCKHOLM_SLUG = "stockholm";

/** Caire marketing contact form — “kontakta oss” from Stockholm CTAs. */
export const CAIRE_CONTACT_URL = "https://www.caire.se/kontakt";

export const OFFICIAL_STOCKHOLM_HOME_CARE_URL =
  "https://aldreomsorg.stockholm/hemtjanst/";
export const OFFICIAL_STOCKHOLM_CHOOSER_URL =
  "https://aldreomsorg.stockholm/hitta-hemtjanst/";
export const OFFICIAL_STOCKHOLM_QUALITY_URL =
  "https://aldreomsorg.stockholm/kvalitet-och-synpunkter/";
export const OFFICIAL_STOCKHOLM_FEES_URL =
  "https://aldreomsorg.stockholm/avgifter-for-aldreomsorg/";

export const STOCKHOLM_GUIDES: readonly GlobalSearchArticle[] = [
  {
    title: "Nya socialtjänstlagen och hemtjänsten i Stockholm",
    slug: "nya-socialtjanstlagen-hemtjanst-stockholm",
    description:
      "Vad lagen betyder för ansökan, förebyggande stöd och hemtjänst i Stockholm.",
    keywords: [
      "nya socialtjänstlagen Stockholm",
      "nya socialtjänstlagen hemtjänst",
      "hemtjänst Stockholm lag",
    ],
  },
  {
    title: "Så fungerar hemtjänst i Stockholm",
    slug: "sa-fungerar-hemtjanst",
    description: "Vad hemtjänst är, vad den kostar och hur du väljer utförare.",
    keywords: [
      "vad är hemtjänst",
      "hur fungerar hemtjänst",
      "hemtjänst Stockholm",
    ],
  },
  {
    title: "Ansöka om hemtjänst i Stockholm",
    slug: "ansoka-hemtjanst-stockholm",
    description: "Från ansökan och biståndsbedömning till beslut.",
    keywords: ["ansöka", "bistånd", "beslut"],
  },
  {
    title: "Vad kostar hemtjänst i Stockholm?",
    slug: "kostnad-hemtjanst-stockholm",
    description: "Avgift, maxtaxa och förbehållsbelopp förklarat.",
    keywords: ["kostnad", "avgift", "maxtaxa"],
  },
  {
    title: "Välja hemtjänstutförare",
    slug: "valja-hemtjanst",
    description: "Jämför källor, arbetssätt, språk och kontinuitet.",
    keywords: ["välja", "jämföra", "utförare"],
  },
  {
    title: "Byta hemtjänst i Stockholm",
    slug: "byta-hemtjanst",
    description: "Praktiska steg när du vill byta utförare.",
    keywords: ["byta", "utförare"],
  },
  {
    title: "Checklista för hemtjänstutförare",
    slug: "checklista-hemtjanstutforare",
    description: "Frågor att ta med till utförare och biståndshandläggare.",
    keywords: ["checklista", "frågor", "jämförelse"],
  },
];

export const STOCKHOLM_SEARCH_CONFIG: GlobalSearchConfig = {
  enabledSources: ["providers", "articles"],
  municipalitySlug: STOCKHOLM_SLUG,
  includeOrganizations: false,
  routes: {
    provider: (slug) => `/utforare/${slug}`,
    article: (article) => `/guider/${article.slug}`,
  },
  articles: STOCKHOLM_GUIDES,
  copy: {
    placeholder: "Sök utförare eller guide…",
    providersHeading: "Hemtjänstutförare",
    articlesHeading: "Guider",
    noResults: "Vi hittade inga utförare eller guider.",
  },
  allResultsCta: {
    label: "Visa alla utförare",
    buildHref: (query) => `/hitta-hemtjanst?q=${encodeURIComponent(query)}`,
  },
};

export const STOCKHOLM_NAV_ITEMS = [
  { label: "Hitta hemtjänst", to: "/hitta-hemtjanst" },
  { label: "Stadsdelar", to: "/stadsdelar" },
  {
    label: "Guider",
    to: "/guider",
    children: STOCKHOLM_GUIDES.map((guide) => ({
      label: guide.title,
      to: `/guider/${guide.slug}`,
    })),
  },
  { label: "Jämför", to: "/jamfor" },
  { label: "Om", to: "/om" },
];

export const STOCKHOLM_NOT_FOUND_LINKS = [
  { label: "Startsidan", to: "/" },
  { label: "Hitta hemtjänst", to: "/hitta-hemtjanst" },
  { label: "Alla stadsdelar", to: "/stadsdelar" },
  { label: "Guider", to: "/guider" },
];
